import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { warningIconBlue } from 'assets/images';
import useIsMobile from 'utils/useIsMobile';

import styles from './style.module.scss';

const ParamsTable = ({ data, title }) => {
  const { t } = useTranslation('global');
  const isMobile = useIsMobile();
  const sortedData = [...data].sort((a, b) => a.id - b.id);

  return (
    <div className={styles.paramsTable}>
      <div className={isMobile ? styles.tableHeaderMobile : styles.tableHeader}>
        <p className={styles.tableHeaderCol1}>
          <b>{title}</b>
        </p>
        <p className={styles.tableHeaderCol1}>
          <b>{t('paramsDescription')}</b>
        </p>
      </div>

      {sortedData?.map(param => (
        <div key={param.id}>
          <div className={isMobile ? styles.tableDataMobile : styles.tableData}>
            <p className={styles.sizeAround}>
              <span
                className={clsx(
                  styles.tag,
                  param.paramType === 'request' ? styles.yellow : styles.green,
                )}>
                {`{:${param.paramName}}`}
              </span>
            </p>
            <span className={styles.textWrap}>
              {param.paramDescription &&
                ((param.paramDescription.includes('\\n') &&
                  param.paramDescription
                    .split('\\n')
                    .map(line => <div key={`line-${line}`}>{line}</div>)) ||
                  (!param.paramDescription.includes('\\n') &&
                    param.paramDescription))}
            </span>
          </div>
          {param.paramNote !== null && (
            <div className={styles.inline_warning}>
              <img className="icon" src={warningIconBlue} alt="inline icon" />
              {param.paramNote !== null && (
                <div className={styles.note}>
                  {param.paramNote.split('\\n').map(line => (
                    <div key={`line-${line}`}>{line}</div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ParamsTable;
